module.exports = __webpack_public_path__ + "img/message-text-circle-02.82771674.svg";